import React, { useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { calculatorConfig, isCalculatorAccessible } from '../config/features';

/**
 * MobileNavBar — bottom nav strip for mobile.
 * Icons only. Active calculator is highlighted. Auto-centers on active icon.
 */
const MobileNavBar = () => {
  const location = useLocation();
  const scrollRef = useRef(null);
  const activeRef = useRef(null);

  const navItems = Object.entries(calculatorConfig).filter(
    ([, calc]) => isCalculatorAccessible(calc) && !calc.excludeFromMobileNav
  );

  useEffect(() => {
    if (activeRef.current && scrollRef.current) {
      try {
        const container = scrollRef.current;
        const active = activeRef.current;
        const containerRect = container.getBoundingClientRect();
        const activeRect = active.getBoundingClientRect();

        const scrollLeft =
          active.offsetLeft - container.offsetLeft - containerRect.width / 2 + activeRect.width / 2;

        if (typeof container.scrollTo === 'function') {
          try {
            container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
          } catch {
            container.scrollLeft = scrollLeft;
          }
        } else {
          container.scrollLeft = scrollLeft;
        }
      } catch {
        // Silently handle scroll errors on older browsers
      }
    }
  }, [location.pathname]);

  return (
    <nav className="bg-surface-card border-t border-border">
      <div
        ref={scrollRef}
        className="flex items-center justify-center gap-1 px-2 py-1.5 overflow-x-auto scrollbar-hide"
        style={{ WebkitOverflowScrolling: 'touch' }}
      >
        {navItems.map(([key, calc]) => {
          const isActive = location.pathname === calc.path || location.pathname.startsWith(calc.path + '/');
          return (
            <Link
              key={key}
              ref={isActive ? activeRef : null}
              to={calc.path}
              className={`flex items-center justify-center flex-shrink-0 w-9 h-9 rounded-lg transition-all duration-150 no-underline ${
                isActive
                  ? 'bg-conform-yellow text-conform-black shadow-sm'
                  : 'text-ink-tertiary hover:bg-hover hover:text-ink-secondary'
              }`}
              title={calc.sideMenu}
              aria-label={calc.sideMenu}
            >
              {React.cloneElement(calc.icon, { size: 16 })}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNavBar;
